<template>
  <g>
    <path
      d="M8.5 17.0002C9.05228 17.0002 9.5 16.5525 9.5 16.0002C9.5 15.4479 9.05228 15.0002 8.5 15.0002C7.94772 15.0002 7.5 15.4479 7.5 16.0002C7.5 16.5525 7.94772 17.0002 8.5 17.0002Z"
    />
    <path
      d="M15.5 17.0002C16.0523 17.0002 16.5 16.5525 16.5 16.0002C16.5 15.4479 16.0523 15.0002 15.5 15.0002C14.9477 15.0002 14.5 15.4479 14.5 16.0002C14.5 16.5525 14.9477 17.0002 15.5 17.0002Z"
    />
    <path
      d="M7.01 9.00018H17.01V14.0002H7.01V9.00018ZM17.8 2.80018C16 2.09018 13.86 2.00018 12 2.00018C10.14 2.00018 8 2.09018 6.2 2.80018C3.53 3.84018 2 6.05018 2 8.86018V22.0002H22V8.86018C22 6.05018 20.47 3.84018 17.8 2.80018ZM18 15.5002C18 17.0402 16.84 18.2902 15.35 18.4602L16.5 19.6202V20.0002H14.83L13.33 18.5002H10.67L9.17 20.0002H7.5V19.6202L8.65 18.4602C7.16 18.2902 6 17.0402 6 15.5002V9.00018C6 6.37018 9 6.00018 12 6.00018C15 6.00018 18 6.37018 18 9.00018V15.5002Z"
    />
  </g>
</template>
